"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Observer2 = require("./Observer");

var _Observer3 = _interopRequireDefault(_Observer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PasswordModel = function (_Observer) {
    _inherits(PasswordModel, _Observer);

    function PasswordModel(observers, id, request) {
        _classCallCheck(this, PasswordModel);

        var _this = _possibleConstructorReturn(this, (PasswordModel.__proto__ || Object.getPrototypeOf(PasswordModel)).call(this, observers, id, request));

        _this.ValidityPeriod = 0;
        _this.PasswordLength = 0;
        _this.CountMinNumbers = 0;
        _this.CountMinLetters = 0;
        _this.CountMinLowerCaseLetters = 0;
        _this.CountMinUpperCaseLetters = 0;
        _this.CountMinSpecialCharacters = 0;
        _this.CountLastPasswords = 0;

        _this.Token = "";
        _this.Role = "";
        _this.UserConfig = "";
        _this.UserName = "";
        _this.RoleConfig = "";
        return _this;
    }

    _createClass(PasswordModel, [{
        key: "GetPaswordPolicy",
        value: function GetPaswordPolicy() {

            var me = this;

            this.request.setRequest("/PasswordPolicy");
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        if (result.Data.ValidityPeriod) {
                            me.ValidityPeriod = result.Data.ValidityPeriod;
                        }
                        if (result.Data.PasswordLength) {
                            me.PasswordLength = result.Data.PasswordLength;
                        }
                        if (result.Data.CountMinNumbers) {
                            me.CountMinNumbers = result.Data.CountMinNumbers;
                        }
                        if (result.Data.CountMinLetters) {
                            me.CountMinLetters = result.Data.CountMinLetters;
                        }
                        if (result.Data.CountMinLowerCaseLetters) {
                            me.CountMinLowerCaseLetters = result.Data.CountMinLowerCaseLetters;
                        }
                        if (result.Data.CountMinUpperCaseLetters) {
                            me.CountMinUpperCaseLetters = result.Data.CountMinUpperCaseLetters;
                        }
                        if (result.Data.CountMinSpecialCharacters) {
                            me.CountMinSpecialCharacters = result.Data.CountMinSpecialCharacters;
                        }
                        if (result.Data.CountLastPasswords) {
                            me.CountLastPasswords = result.Data.CountLastPasswords;
                        }
                    }
                }

                var id = me.Id ? me.Id : "PaswordPolicy";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: "ChangePassword",
        value: function ChangePassword(passwordOld, passwordNew) {
            var me = this;

            if (passwordOld !== null && passwordOld !== undefined && passwordNew !== null && passwordNew !== undefined) {
                this.request.setRequest("/AccountsChangePw");
                this.request.setType("POST");
                this.request.setData(JSON.stringify({
                    passwordOld: passwordOld,
                    passwordNew: passwordNew
                }));
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            if (result.Token) {
                                me.Token = result.Data.Token;
                            }
                            if (result.Role) {
                                me.Role = result.Data.Role;
                            }
                            if (result.UserConfig) {
                                me.UserConfig = result.Data.UserConfig;
                            }
                            if (result.UserName) {
                                me.UserName = result.Data.UserName;
                            }
                            if (result.RoleConfig) {
                                me.RoleConfig = result.Data.RoleConfig;
                            }
                        }
                    }

                    var id = me.Id ? me.Id : "ChangePassword";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }]);

    return PasswordModel;
}(_Observer3.default);

exports.default = PasswordModel;